import { ComponentProps } from "react";
import { Button } from "../../button";
import "./generic-error.scss";
import { useAppSelector } from "../../../../hooks/hooks";
import {
  selectLanguage,
  selectTranslations,
} from "../../../data-access/store/general/generalSlice";
import { checkTranslationKey } from "../../../../utils/translation";

export interface GenericErrorProps extends ComponentProps<"div"> {
  onButtonClick: () => void;
  buttonText?: string;
}

export function GenericError({
  onButtonClick,
  buttonText,
  ...props
}: GenericErrorProps) {
  const lang = useAppSelector(selectLanguage);
  const translations = useAppSelector(selectTranslations);

  return (
    <div className="generic-error-modal modal-content" {...props}>
      <div className="top-area">
        <div className="title">
          {checkTranslationKey(translations[lang]?.Oops, "Oops!")}
        </div>
        <div className="message-icon">
          <img src="../img/icns/error.png" alt="" width="80em" />
        </div>
        <div className="message">
          {checkTranslationKey(
            translations[lang]?.An_error_has_occurred_Please_try_again,
            "An error has occurred. Please try again."
          )}
        </div>
      </div>
      <div className="bottom-area">
        <Button onClick={onButtonClick} buttonType="success">
          {buttonText ||
            checkTranslationKey(translations[lang]?.Homepage, "Homepage")}
        </Button>
      </div>
    </div>
  );
}

export default GenericError;
